module.exports = __webpack_public_path__ + "static/img/jigou-zhuhai-top.c3907ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-zhuhai-top.png
// module id = FXFr
// module chunks = 2